import moment from 'moment'
import i18n from '../../plugins/i18n'
import store from '../../store'

const account = {
  info: function (subscription, subscriptionValidUntil) {
    let account = null
    if (subscription === 'pro' && subscriptionValidUntil) {
      let remainingDays = moment(subscriptionValidUntil).diff(moment(), 'days')
      if (remainingDays >= 0) {
        account = {
          color: 'green lighten-4',
          type: 'pro',
          name: 'PRO ' + i18n.t('general.subscription'),
          text: i18n.t('extend.professional.account'),
          remainingDays: remainingDays,
          validText: i18n.t('plan.valid.until') + ': ' + moment(subscriptionValidUntil).format(store.state.settings.dateFormat) + ' (' + remainingDays + ' ' + i18n.t('general.days') + ')',
          validUntil: subscriptionValidUntil,
          validUntilNew: moment(subscriptionValidUntil).add(1, 'days').add(1, 'years').format('YYYY-MM-DD')
        }
      } else {
        account = {
          color: 'grey lighten-4',
          type: 'basic',
          name: 'Basic ' + i18n.t('general.subscription'),
          text: i18n.t('general.switchToPro'),
          remainingDays: remainingDays,
          expiredText: i18n.t('professinal.expiredOn').replace('__VALID_UNTIL__', subscriptionValidUntil),
          validUntil: subscriptionValidUntil,
          validUntilNew: moment().add(1, 'days').add(1, 'years').format('YYYY-MM-DD')
        }
      }
    } else if (subscription === 'business' && subscriptionValidUntil) {
      let remainingDays = moment(subscriptionValidUntil).diff(moment(), 'days')
      if (remainingDays >= 0) {
        account = {
          color: 'green lighten-4',
          type: 'business',
          name: 'BUSINESS ' + i18n.t('general.subscription'),
          text: i18n.t('extend.professional.account'),
          remainingDays: remainingDays,
          validText: i18n.t('plan.valid.until') + ': ' + moment(subscriptionValidUntil).format(store.state.settings.dateFormat) + ' (' + remainingDays + ' ' + i18n.t('general.days') + ')',
          validUntil: subscriptionValidUntil,
          validUntilNew: moment(subscriptionValidUntil).add(1, 'days').add(1, 'years').format('YYYY-MM-DD')
        }
      } else {
        account = {
          color: 'grey lighten-4',
          type: 'basic',
          name: 'Basic ' + i18n.t('general.subscription'),
          text: i18n.t('general.switchToPro'),
          remainingDays: remainingDays,
          expiredText: i18n.t('professinal.expiredOn').replace('__VALID_UNTIL__', subscriptionValidUntil),
          validUntil: subscriptionValidUntil,
          validUntilNew: moment().add(1, 'days').add(1, 'years').format('YYYY-MM-DD')
        }
      }
    } else {
      account = {
        color: 'grey lighten-4',
        type: 'basic',
        name: 'Basic ' + i18n.t('general.subscription'),
        text: i18n.t('general.switchToPro'),
        validUntilNew: moment().add(1, 'days').add(1, 'years').format('YYYY-MM-DD')
      }
    }
    return account
  }
}

export default account



// WEBPACK FOOTER //
// ./src/client/lib/account.js